"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachIframeContextListener = void 0;
var request_1 = __importStar(require("../utils/request"));
var iframeId = 'salsify-ec-iframe';
var prodCdnOrigin = 'https://salsify-ecdn.com';
var stagingCdnOrigin = 'https://staging.salsify-ecdn.com';
var prodCdnPrefix = 'sdk';
var stagingCdnPrefix = 'sdk';
// The message types also used in enhanced-content-renderer for posting messages
var messageTypes = {
    heightUpdateRequest: 'heightUpdateRequest',
    contextRequest: 'contextRequest',
};
var attachedIframeEventListener = false;
function messageFromSalsifyCDN(event) {
    return event.origin === prodCdnOrigin || event.origin === stagingCdnOrigin;
}
var attachIframeResizeListener = function () {
    if (attachedIframeEventListener) {
        return;
    }
    window.addEventListener('message', function (event) {
        if (!messageFromSalsifyCDN(event)) {
            return;
        }
        // if `messageType` isn't defined, it means the EC is an older version and sent
        // a height update request without the type included, so we need to handle it
        if (event.data.messageType && event.data.messageType !== messageTypes.heightUpdateRequest) {
            return;
        }
        var iframe = document.querySelector("#".concat(iframeId));
        if (iframe) {
            iframe.height = event.data.height;
        }
    });
    attachedIframeEventListener = true;
};
/**
 * MessageEventSource can be one of the following: WindowProxy, MessagePort, or ServiceWorker.
 * For some browsers, WindowProxy is not defined, and its not equal to Window.
 * The postMessage method for them has different method argument.
 * WindowProxy have a second argument for targetOrigin, while other two's second argment is WindowPostMessageOption Object.
 * Therefore, we will want to know what the source type is so we can call the postMessage method correctly.
 */
function messageEventSourceIsWindow(source) {
    return ((!('MessagePort' in window) || !(source instanceof MessagePort)) &&
        (!('ServiceWorker' in window) || !(source instanceof ServiceWorker)) &&
        !!source.postMessage);
}
var attachIframeContextListener = function (context) {
    window.addEventListener('message', function (event) {
        if (!event.source || !messageFromSalsifyCDN(event)) {
            return;
        }
        if (event.data.messageType !== messageTypes.contextRequest) {
            return;
        }
        // If event has channel ports, post the messages back via the ports.
        if (event.ports.length) {
            event.ports.forEach(function (port) {
                port.postMessage(context);
            });
        }
        else if (messageEventSourceIsWindow(event.source)) {
            event.source.postMessage(context, event.origin);
        }
        else {
            event.source.postMessage(context);
        }
    });
};
exports.attachIframeContextListener = attachIframeContextListener;
/**
 * The Enhanced Content API.
 *
 * This is the main entry point for everything to do with Enhanced Content.
 *
 * This API can be used to check for, as well as render EC in both client and server side environments.
 */
var EnhancedContentApi = /** @class */ (function () {
    /** @internal */
    function EnhancedContentApi(settings, logger, options) {
        this.settings = settings;
        this.logger = logger;
        this.options = options;
    }
    /**
     * Checks if the given combination of `productId` and `idType` have Enhanced Content.
     *
     * **Usage**
     ```javascript
     const salsify = window.salsifyExperiencesSdk;
     let hasContent;
     function callback(exists) { hasContent = exists; }
     salsify.enhancedContent.exists(productId, idType).then(callback);
     ```
     * @param productId string ID for the product
     * @param idType the IDTYPE for the product
     * @returns `true` if the product has content, `false` otherwise
     */
    EnhancedContentApi.prototype.exists = function (productId, idType) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.buildContentUrl(productId, this.checkAndGetIdType(idType));
                        return [4 /*yield*/, request_1.default.head(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.headers[request_1.Header.ContentLength] !== '0'];
                }
            });
        });
    };
    /**
     * Renders the Enhanced Content for the given `productId` and `idType` into an iFrame that is inserted into the provided `container`.
     *
     * **Usage**
     ```javascript
     const salsify = window.salsifyExperiencesSdk;
     const element = document.getElementById('enhanced-content-container');
     salsify.enhancedContent.renderIframe(element, productId, idType);
     ```
     * @param container the DOM element to render the content into
     * @param productId string ID for the product
     * @param idType the IDTYPE for the product
     */
    EnhancedContentApi.prototype.renderIframe = function (container, productId, idType) {
        var _a;
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.beforeRender) {
            this.options.beforeRender(productId, idType);
        }
        idType = this.checkAndGetIdType(idType);
        attachIframeResizeListener();
        var iframe = this.createIframe();
        iframe.src = this.buildContentUrl(productId, idType);
        iframe.title = 'Salsify Enhanced Content';
        container.appendChild(iframe);
        this.logger.log('ec_render_iframe', { idType: idType, productId: productId });
    };
    /**
     * Returns the HTML content for the given `productId` and `idType` as a string.
     *
     * **Usage**
     ```javascript
     import salsify from 'salsify-experiences-sdk';
     salsify.enhancedContent.renderToString(productId, idType);
     ```
     * @param productId string ID for the product
     * @param idType the IDTYPE for the product
     * @returns the content for the given product ID and ID Type
     */
    EnhancedContentApi.prototype.renderToString = function (productId, idType) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var html;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.beforeRender) {
                            this.options.beforeRender(productId, idType);
                        }
                        idType = this.checkAndGetIdType(idType);
                        return [4 /*yield*/, this.get(productId, idType)];
                    case 1:
                        html = _b.sent();
                        this.logger.log('ec_render_string', { idType: idType, productId: productId });
                        return [2 /*return*/, html];
                }
            });
        });
    };
    /**
     * Updates the language code for subsequent Enhanced Content requests.
     *
     * **Usage**
     ```javascript
     const salsify = window.salsifyExperiencesSdk;
     salsify.enhancedContent.updateLanguageCode('fr-CA');
     // this call now uses the new language code, "fr-CA"
     salsify.enhancedContent.exists(productId, idType);
     ```
     * @param languageCode the language code to use for subsequent calls
     */
    EnhancedContentApi.prototype.updateLanguageCode = function (languageCode) {
        this.settings = __assign(__assign({}, this.settings), { languageCode: languageCode });
        this.logger.log('ec_update_language_code', { languageCode: languageCode });
    };
    /**
     * Get Enhanced Content url for the given `productId` and `idType`.
     *
     * **Usage**
     ```javascript
     const salsify = window.salsifyExperiencesSdk;
     salsify.enhancedContent.contentUrl(productId, idType);
     ```
     * @param productId string ID for the product
     * @param idType the IDTYPE for the product
     */
    EnhancedContentApi.prototype.contentUrl = function (productId, idType) {
        this.logger.log('ec_get_content_url', { idType: idType, productId: productId });
        return this.buildContentUrl(productId, this.checkAndGetIdType(idType));
    };
    EnhancedContentApi.prototype.get = function (productId, idType) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.buildContentUrl(productId, this.checkAndGetIdType(idType));
                        return [4 /*yield*/, request_1.default.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    EnhancedContentApi.prototype.checkAndGetIdType = function (idType) {
        if (idType) {
            return idType;
        }
        if (this.settings.enhancedContent.idType) {
            return this.settings.enhancedContent.idType;
        }
        throw new Error('No ID type specified.');
    };
    EnhancedContentApi.prototype.createIframe = function () {
        var iframe = document.createElement('iframe');
        iframe.id = iframeId;
        iframe.height = '0';
        iframe.width = '100%';
        iframe.style.border = '0';
        iframe.scrolling = 'no';
        return iframe;
    };
    EnhancedContentApi.prototype.buildContentUrl = function (productId, idType) {
        var cdnOrigin = this.settings.staging ? stagingCdnOrigin : prodCdnOrigin;
        var cdnPrefix = this.settings.staging ? stagingCdnPrefix : prodCdnPrefix;
        return "".concat(cdnOrigin, "/").concat(cdnPrefix, "/").concat(this.settings.clientId, "/").concat(this.settings.languageCode, "/BTF/").concat(idType, "/").concat(productId, "/index.html");
    };
    return EnhancedContentApi;
}());
exports.default = EnhancedContentApi;
//# sourceMappingURL=index.js.map